import {
  setHours,
  setMinutes,
  setSeconds,
  parseJSON,
  addMinutes,
  endOfDay,
  startOfDay,
  eachDayOfInterval,
  parseISO,
  format,
  addSeconds,
  differenceInMinutes,
  isEqual,
  isSameDay,
  addDays,
  isValid,
  parse
} from "date-fns";

export const danishFormat = "dd-MM-yyyy";
export const danishFormatRegex = /\d{2}-\d{2}-\d{4}/;

export enum dayInWeek {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAYS = 6,
  SUNDAY = 0
}

// tslint:disable-next-line: typedef
export const SetHours = (dato: Date | string, Hour: string): Date => {
  let resultdate: Date = parseJSON(dato);
  const s: string[] = Hour.split(":");
  if (s.length > 0) {
    resultdate = setHours(resultdate, parseInt(s[0], 0));
    if (s.length > 1) {
      resultdate = setMinutes(resultdate, parseInt(s[1], 0));
      if (s.length > 2) {
        resultdate = setSeconds(resultdate, parseInt(s[2], 0));
      } else {
        resultdate = setSeconds(resultdate, 0);
      }
    } else {
      resultdate = setMinutes(resultdate, 0);
      resultdate = setSeconds(resultdate, 0);
    }
  } else {
    resultdate = setHours(resultdate, 0);
    resultdate = setMinutes(resultdate, 0);
    resultdate = setSeconds(resultdate, 0);
  }
  return resultdate;
};

export const dateFromApi = (date: Date | string): Date => {
  if (!date) {
    // what to do when passed an undefined date
    throw new Error(
      "Passed value was undefined when it should have been either a date object or a string."
    );
  }

  if (date instanceof Date) {
    return date;
  }
  return parseISO(date as string);
};

export const convertDateToUtc = (date): Date => {
  const offset: number = 0 - date.getTimezoneOffset();
  return addMinutes(date, offset);
};

export const objectToDate = (obj): Date => {
  if ((typeof obj as any) === "string") {
    return parseISO(obj as any);
  } else {
    return obj as Date;
  }
};
export const convertDateOnlyToUtc = (date: Date) => {
  return format(date, "yyyy-MM-dd");
};

export const convertDateTimeToUtc = (date) => {
  return format(date, "yyyy-MM-dd'T'HH:mm");
};

export const timeFormatToMinutets = (minutes: string): number => {
  const timeRegex = /(0[0-9]|1[0-9]|2[0-3]|[0-9]):([0-5][0-9])/;
  if (minutes.length == 1) {
    minutes = "0" + minutes;
  }
  minutes = minutes.replace(":", "") + "0000";
  minutes = minutes.substr(0, 2) + ":" + minutes.substr(2, 2);
  const res = minutes.match(timeRegex);
  if (res) {
    return +res[2] + +res[1] * 60;
  } else {
    return 0;
  }
};

export const dateToMinuts = (date: Date): number => {
  const startday = startOfDay(date);
  return differenceInMinutes(date, startday);
};

export const minutsToHoursShort = (totalMinutes: number): string => {
  if (!totalMinutes) {
    return "0";
  }
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);

  const returnstr = `${hours}:${minutes.toString().padStart(2, "0")}`;
  return returnstr.replace(":00", "");
};

export const minutesToTimeFormat = (totalMinutes: number, sumMultiple = false): string => {
  if (!sumMultiple && (!totalMinutes || totalMinutes === 0 || totalMinutes === 1440)) {
    return "00:00";
  }
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

export const timeToMinutes = (time: string, toTime = false): number => {
  if (toTime && time === "00:00") {
    return 1440; // 24:00
  }
  const hours: number = parseInt(time.split(":")[0]);
  const minutes: number = parseInt(time.split(":")[1]);
  return hours * 60 + minutes;
};

export const formatTimeString = (value: string): string => {
  if (!value) {
    return "";
  }
  const timeRegex = /(0[0-9]|1[0-9]|2[0-3]|[0-9]):([0-5][0-9])/;
  value = value.replaceAll("_", "").replace(":", "");
  if (!timeRegex.test(value) || value.length !== 5) {
    if (value.length == 1) {
      value = "0" + value;
    }
    const timeVal = (value + "0000").substr(0, 4);
    if (timeVal.length < 5 && isValid(parse(timeVal, "HHmm", new Date()))) {
      value = format(parse(timeVal, "HHmm", new Date()), "HH:mm");
    }
  }
  return value;
};

export const isTimeValid = (value: string): boolean => {
  if (!value || value.length == 0) {
    return true;
  }
  return isValid(parse(value, "HH:mm", new Date()));
};

export const getDateOfISOWeek = (w: number, y: number): Date => {
  const simple = new Date(y, 0, 1 + (w - 1) * 7);
  const dow = simple.getDay();
  const ISOweekStart = simple;
  if (dow <= 4) {
    ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  } else {
    ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  }
  return ISOweekStart;
};

/**
 * Iperiode functions
 */
export interface IPeriode {
  fra: Date;
  tilOgMed: Date;
  Objects?: any[];
}

export const newTimeperiod = (): IPeriode => {
  return {
    fra: new Date(),
    tilOgMed: new Date()
  };
};

export const newSearchSpace = (period1: IPeriode, period2: IPeriode): IPeriode => {
  const maxSearch = endOfDay(getMaxTo(period1, period2));
  const lowSearch = startOfDay(getLowestFrom(period1, period2));

  return {
    fra: lowSearch,
    tilOgMed: maxSearch
  };
};

export const areTimeperiodsOverlapping = (period1: IPeriode, period2: IPeriode) => {
  return period1.fra < period2.tilOgMed && period2.fra < period1.tilOgMed;
};

export const getMaxTo = (period1: IPeriode, period2: IPeriode): Date => {
  return period1.tilOgMed > period2.tilOgMed ? period1.tilOgMed : period2.tilOgMed;
};

export const getLowestFrom = (period1: IPeriode, period2: IPeriode): Date => {
  return period1.fra < period2.fra ? period1.fra : period2.fra;
};

export const isCompletelyWrapped = (bigPeriod: IPeriode, smallPeriod: IPeriode): boolean => {
  return smallPeriod.fra >= bigPeriod.fra && smallPeriod.tilOgMed <= bigPeriod.tilOgMed;
};

export const overlapDay = (period: IPeriode, date: Date): boolean => {
  return period.fra <= date && period.tilOgMed >= date;
};

export const getDatesBetween = (period: IPeriode): Date[] => {
  return eachDayOfInterval({
    start: period.fra,
    end: period.tilOgMed
  });
};

export const getIntersectionDatetime = (
  periode1: IPeriode,
  periode2: IPeriode
): IPeriode | undefined => {
  let objects: any[] | undefined = [...(periode1.Objects || []), ...(periode2.Objects || [])];
  if (objects.length === 0) {
    objects = undefined;
  }
  if (periode1.fra < periode2.fra && periode1.tilOgMed > periode2.tilOgMed) {
    // 1:   #########################
    // 2:        #############
    return { fra: periode2.fra, tilOgMed: periode2.tilOgMed, Objects: objects } as IPeriode;
  } else if (periode2.fra < periode1.fra && periode2.tilOgMed > periode1.tilOgMed) {
    // 1:        #############
    // 2:   #########################
    return { fra: periode1.fra, tilOgMed: periode1.tilOgMed, Objects: objects } as IPeriode;
  } else if (
    periode1.fra > periode2.fra &&
    periode1.tilOgMed > periode2.tilOgMed &&
    periode1.fra < periode2.tilOgMed &&
    periode1.tilOgMed > periode2.fra
  ) {
    // 1:              #############
    // 2:        #############
    return { fra: periode1.fra, tilOgMed: periode2.tilOgMed, Objects: objects } as IPeriode;
  } else if (
    periode2.fra > periode1.fra &&
    periode2.tilOgMed > periode1.tilOgMed &&
    periode2.fra < periode1.tilOgMed &&
    periode2.tilOgMed > periode1.fra
  ) {
    // 1:        #############
    // 2:              #############
    return {
      fra: periode2.fra,
      tilOgMed: periode1.tilOgMed,
      Objects: objects
    } as IPeriode;
  } else if (isEqual(periode1.fra, periode2.fra) || isEqual(periode1.tilOgMed, periode2.tilOgMed)) {
    // 1: #####
    // 2: ##
    // or
    // 1: #####
    // 2:    ##
    // or
    // 1: #####
    // 2: #####
    return {
      fra: periode1.fra > periode2.fra ? periode1.fra : periode2.fra,
      tilOgMed: periode1.tilOgMed < periode2.tilOgMed ? periode1.tilOgMed : periode2.tilOgMed,
      Objects: objects
    };
  }
  return undefined;
};

export const mergePeriods = (periods: IPeriode[]): IPeriode[] => {
  const sortedPeriods = [...periods].sort((a, b) => {
    if (a.fra > b.fra) {
      return 1;
    }
    if (a.fra < b.fra) {
      return -1;
    }

    return 0;
  });

  const output: IPeriode[] = [];

  let currentlyMerging: IPeriode | null = null;

  const periodsLength = sortedPeriods.length;
  for (let i = 0; i <= periodsLength; i++) {
    if (i === periodsLength) {
      // we have processed the last element in the list, push the current merging onto the output stack
      if (currentlyMerging) {
        output.push(currentlyMerging);
      }
      return output;
    }

    const current = sortedPeriods[i];

    if (currentlyMerging === null) {
      currentlyMerging = current; // we are the very first one, skipping
      continue;
    }

    const overlap =
      currentlyMerging.fra < current.tilOgMed && current.fra < currentlyMerging.tilOgMed; // if they overlap
    const dayDiff = isSameDay(addDays(currentlyMerging.tilOgMed, 1), current.fra); // if they are only seperated by one day

    if (overlap || dayDiff) {
      if (!(current.tilOgMed <= currentlyMerging.tilOgMed)) {
        // if current.to is before currentlyMergin.to, the period can be considered already merged
        currentlyMerging.tilOgMed = current.tilOgMed;
      }
    } else {
      output.push(currentlyMerging);
      currentlyMerging = current;
    }
  }

  return output;
};
